module.exports = __webpack_public_path__ + "static/img/split_knowledge_item.9237b05f.png";